import { Checkbox, Field, FieldContainer } from '@cademy-ui/form';
import { OriginString } from '@shared/types';
import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, useId, useMemo } from 'react';
import styles from './styles.module.scss';

export type MarketingConsentFieldProps = {
    name: string;
    origin: OriginString;
    educator: PublicEducator;
};

export const MarketingConsentField: FunctionComponent<MarketingConsentFieldProps> = ({
    name,
    origin,
    educator,
}) => {
    const id = useId();

    const consentText = useMemo(() => {
        if (origin === 'marketplace') {
            return "It's ok to send me occasional recommendations by email.";
        }
        return `I'm happy to receive occasional emails from ${educator.name}.`;
    }, [origin, educator]);

    if (educator.feature_flags?.hide_marketing_consent) return null;

    return (
        <Field<boolean> name={name} initialValue={false}>
            {({ value, setValue, descriptionId, errorId, errors }) => {
                return (
                    <FieldContainer
                        className={styles.consent}
                        descriptionId={descriptionId}
                        errorId={errorId}
                        errors={errors}
                    >
                        <Checkbox
                            id={id}
                            isChecked={value || false}
                            onChange={setValue}
                            label={consentText}
                        />
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
